import React from 'react';

interface ViewProps {
  width?: number;
  height?: number;
}

export const StackedView = ({ width = 66, height = 50 }: ViewProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 67 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.833374"
      y="0.5"
      width="65"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect
      x="0.833374"
      y="18.5"
      width="65"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect
      x="0.833374"
      y="36.5"
      width="65"
      height="13"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
  </svg>
);
